import { gql } from '@apollo/client';

export const fetchInflightInvoice = gql`
  query fetchInflightInvoice($id: ID!) {
    transactionAccount(id: $id) {
      id
      pendingInvoices
    }
  }
`;

export const fetchInflightInvoiceForInvoiceGroup = gql`
  query fetchInflightInvoiceForInvoiceGroup($id: ID!) {
    invoiceGroup(id: $id) {
      id
      pendingInvoices
    }
  }
`;
